 
import styled from 'styled-components';
import theme from 'v3/theme';

export const notificationContainer = styled.div`
  overflow-y: auto;
  width: 320px;
  max-width: calc(100vw - 24px);
  max-height: 70vh;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 12px 30px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
  min-height: 120px;

  &.dropdown-menu {
    left: 50%;
    right: auto;
    transform: translateX(-50%) !important;
    margin-top: 8px;
    overflow-x: visible;
    overflow-y: auto;
  }

  &.dropdown-menu::before {
    content: '';
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    width: 28px;
    height: 14px;
    background: #fff;
    border-radius: 14px 14px 0 0;
    box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.06);
    z-index: 1;
  }
`;

export const Notification = styled.div`
  cursor: pointer;
  transition: opacity 0.1s ease-in;
  border-bottom: 1px solid ${theme.colors.gray};
  background-color: ${theme.colors.light};
  padding: 15px;

  &:hover {
    opacity: 0.8;
  }

  &.is-read {
    background-color: #fff;

    &:hover {
      #text-hover {
        color: ${theme.colors.dark} !important;
      }
    }
  }
`;
